import React from 'react';
import './App.css';
import BudgetQuest from './BudgetQuest';

function App() {
  return <BudgetQuest />;
}

export default App;
